exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-card[data-v-512cfa8d] { margin-bottom: 20px;\n}\n.table-card[data-v-512cfa8d] { margin-top: 0;\n}\n.dialog-footer[data-v-512cfa8d] { text-align: right;\n}\n", ""]);

// exports
